import { createFileRoute } from '@tanstack/react-router';
import { Schema } from 'effect';
import { ConnectLoginPage } from '@/components/web-fe/features/connect-app/connect-login-page';

const ConnectLoginSearch = Schema.Struct({
  oauth_query: Schema.String,
  error: Schema.optional(Schema.Unknown),
});

export const Route = createFileRoute('/app/connect/login')({
  validateSearch: Schema.toStandardSchemaV1(ConnectLoginSearch),
  head: () => ({ meta: [{ name: 'robots', content: 'noindex, nofollow' }] }),
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  return (
    <ConnectLoginPage
      oauthQuery={search.oauth_query}
      signInIncomplete={search.error !== undefined}
    />
  );
}
